import storage from '@/services/storage.js'
import {
    createRouter,
    createWebHistory
} from 'vue-router'

import Main from "@/views/Main.vue";
import Home from "@/views/Home.vue"
import Login from "@/views/Login.vue"
import EmbedLogin from "@/views/EmbedLogin.vue"
import Macchine from "@/views/Macchine.vue"
import MacchinaDettaglio from "@/views/MacchinaDettaglio.vue"
import Configurazione from "@/views/Configurazione.vue"
import Utenti from "@/views/Utenti.vue"
import TipiManutenzione from "@/views/TipiManutenzione.vue"
import Magazzino from "@/views/Magazzino.vue"
import Calendario from "@/views/Calendario.vue"
import Storico from "@/views/Storico.vue"

import Aziende from "@/views/Aziende.vue"
import AziendaDettaglio from "@/views/AziendaDettaglio.vue"

import Mezzi from "@/views/Mezzi.vue"
import MezzoDettaglio from "@/views/MezzoDettaglio.vue"
import TipiScadenzaMezzo from "@/views/TipiScadenzaMezzo.vue"

import Pagamenti from "@/views/Pagamenti.vue"
import TipiPagamento from "@/views/TipiPagamento.vue"
import Fornitori from "@/views/Fornitori.vue"

import Incassi from "@/views/Incassi.vue"
import TipiIncasso from "@/views/TipiIncasso.vue"
import Clienti from "@/views/Clienti.vue"

import Profilo from "@/views/Profilo.vue"
import MiaAzienda from "@/views/MiaAzienda.vue"
import Notifiche from "@/views/Notifiche.vue"

import Sicurezza from "@/views/Sicurezza.vue"
import DispositivoSicurezzaDettaglio from "@/views/DispositivoSicurezzaDettaglio.vue"
import TipiSicurezza from "@/views/TipiSicurezza.vue"

const routes = [{
    path: "/",
    meta: {
        auth: true
    },
    component: Main,

    children: [
        {
            path: "/macchine",
            component: Macchine,
        },
        {
            path: "/macchine/:id",
            component: MacchinaDettaglio,
            props: true,
        },
        {
            path: "/configurazione",
            component: Configurazione,
            meta: {
                auth: true,
                roles: ["Admin", "SuperAdmin"], // Configurazione: fuori dalla portata di Operatore/Visualizzatore
            },
        },
        {
            path: "/utenti",
            component: Utenti,
            meta: {
                auth: true,
                roles: ["Admin"], // Gestione utenti della propria azienda: il SuperAdmin ha /aziende/:id
            },
        },
        {
            path: "/aziende",
            component: Aziende,
            meta: {
                auth: true,
                roles: ["SuperAdmin"],
            },
        },
        {
            path: "/aziende/:id",
            component: AziendaDettaglio,
            props: true,
            meta: {
                auth: true,
                roles: ["SuperAdmin"],
            },
        },
        {
            path: "/tipi-manutenzione",
            component: TipiManutenzione,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            path: "/magazzino",
            component: Magazzino,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            path: "/calendario",
            component: Calendario,
        },
        {
            path: "/storico",
            component: Storico,
        },
        {
            // Mezzi: stesso pattern di Macchine, nessun vincolo di ruolo (leggibile
            // da tutti gli autenticati, come Macchine/Manutenzioni).
            path: "/mezzi",
            component: Mezzi,
        },
        {
            path: "/mezzi/:id",
            component: MezzoDettaglio,
            props: true,
        },
        {
            path: "/tipi-scadenza-mezzo",
            component: TipiScadenzaMezzo,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            // Pagamenti: riservati interamente al ruolo Admin (lettura e scrittura),
            // a differenza di Macchine/Manutenzioni/Mezzi.
            path: "/pagamenti",
            component: Pagamenti,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            path: "/tipi-pagamento",
            component: TipiPagamento,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            path: "/fornitori",
            component: Fornitori,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            // Incassi: stesso pattern di Pagamenti, riservati interamente al ruolo Admin.
            path: "/incassi",
            component: Incassi,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            path: "/tipi-incasso",
            component: TipiIncasso,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            path: "/clienti",
            component: Clienti,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            // Profilo personale: nessun vincolo di ruolo, ogni utente autenticato
            // gestisce i propri dati/password. Il link nel menu account (ToolBar.vue)
            // punta già qui.
            path: "/profilo",
            component: Profilo,
        },
        {
            // Dati anagrafici e logo della propria azienda: solo Admin, sempre sul
            // proprio tenant (mai un id arbitrario, a differenza di /aziende/:id
            // che resta esclusiva del SuperAdmin su un tenant scelto).
            path: "/mia-azienda",
            component: MiaAzienda,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            // Notifiche personali: nessun vincolo di ruolo, ogni utente vede solo
            // le proprie (filtrate lato backend per UserId).
            path: "/notifiche",
            component: Notifiche,
        },
        {
            // Sicurezza (estintori/cassette/consumabili): stesso pattern di Mezzi,
            // nessun vincolo di ruolo (dato operativo, non finanziario).
            path: "/sicurezza",
            component: Sicurezza,
        },
        {
            path: "/sicurezza/:id",
            component: DispositivoSicurezzaDettaglio,
            props: true,
        },
        {
            path: "/tipi-sicurezza",
            component: TipiSicurezza,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            path: "/:catchAll(.*)",
            component: Home,
        },
        {
            path: "/",
            meta: {
                auth: true
            },
            component: Home,
        },

    ]
}, {
    path: "/login",
    name: "LoginPage",
    component: Login,
}, {
    path: "/embed-login",
    name: "EmbedLoginPage",
    component: EmbedLogin,
}]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})


router.beforeEach((to, from, next) => {

    if (to.path == "/@esci") storage.logout();

    // Modalità embed (nasconde toolbar/leftbar, per l'integrazione in webview di
    // sistemi esterni): il flag va salvato appena visto, PRIMA di un eventuale
    // redirect al login, così sopravvive al giro di login manuale e resta attivo
    // su tutte le sottopagine visitate in seguito (letto da sessionStorage, non
    // dalla query string della singola richiesta).
    if (to.query.embed === '1') storage.setEmbedMode();

    // Controllo se è richiesta l'autenticazione. Se la destinazione non è la
    // home, la memorizzo in query così dopo il login si torna lì (es. link
    // diretto a una macchina da QR code) invece di atterrare sempre su "/".
    if (to.path != "/login" && to.meta.auth && !storage.checkAuth()) {
        next({
            path: '/login',
            query: to.fullPath !== '/' ? { redirect: to.fullPath } : undefined,
        })
        return
    }
    // Controllo pagina login
    else if (to.path == "/login" && storage.checkAuth()) {

        // Se il login è stato fatto, vado alla pagina riservata
        next({
            path: '/'
        })

        return
    }

    // Controllo ruoli (RBAC lato frontend: usabilità, non è la vera barriera
    // di sicurezza, che resta il backend con [Authorize(Roles=...)])
    if (to.meta.roles && to.meta.roles.length > 0) {
        const ruolo = storage.getRole ? storage.getRole() : null
        if (ruolo && !to.meta.roles.includes(ruolo)) {
            next({ path: '/' })
            return
        }
    }

    next();

})
export default router